import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Autocomplete, TextField } from "@mui/material";
import { useState } from "react";

import { GeoCrushingLoaderDTO } from "../../../DTOs/Geology/GeoCrushingLoaderDTO";
import { GeoRehandleDTO } from "../../../DTOs/Geology/GeoRehandleDTO";

type LoaderCellProps = {
  entry: GeoRehandleDTO
  loaderOptions: GeoCrushingLoaderDTO[]
  isLoaderOptionsLoading: boolean
  handleUpdateRow: (row: GeoRehandleDTO) => Promise<boolean | undefined>
  isShiftLocked: boolean
}

const LoaderCell: React.FC<LoaderCellProps> = ({
  entry,
  loaderOptions,
  isLoaderOptionsLoading,
  handleUpdateRow,
  isShiftLocked
}) => {
  const [isLoading, setLoading] = useState(false);

  return (
    <Autocomplete
      classes={{ root: 'w-full' }}
      size="small"
      loading={isLoaderOptionsLoading || isLoading}
      disabled={isLoaderOptionsLoading || isLoading || isShiftLocked}
      options={loaderOptions}
      getOptionLabel={(option) => option.plantRef}
      value={loaderOptions.find(x => x.operationId === entry.operationId) ?? null}
      isOptionEqualToValue={(option, value) => option.plantId === value.plantId}
      onChange={async (_event, newValue) => {
        if (newValue) {
          setLoading(true);
          await handleUpdateRow(
            {
              ...entry,
              bucketTypeId: newValue.bucketTypeId,
              plantId: newValue.plantId,
              operationId: newValue.operationId
            }
          );
          setLoading(false);
        }
      }}
      renderInput={(params) => <TextField
        {...params}
        label="Loader"
        slotProps={{
          ...params.slotProps,
          input: {
            ...params.slotProps.input,
            endAdornment: (
              <>
                {(isLoading || isLoaderOptionsLoading) && <FontAwesomeIcon icon={faSpinner} spin />}
                {params.slotProps.input.endAdornment}
              </>
            )
          }
        }}
      />}
    />
  );
};

export default LoaderCell;